<app-funding-item-details
    [currentUser]="currentUser$ | async"
    [fundingItem]="fundingItem$ | async"
    [fundingItemLoading]="fundingItemLoading$ | async"
    [fundingItemTransactions]="fundingItemTransactions$ | async"
    [fundingItemTransactionsLoading]="fundingItemTransactionsLoading$ | async"
    [fundingItemTransactionsError]="fundingItemTransactionsError$ | async"
    [fundingItemExportLoading]="fundingItemExportLoading$ | async"
    [transactionsPager]="fundingItemTransactionsPager$ | async"
    (transactionsPageChanged)="onFundingItemTransactionsPageChanged($event)"
    [transactionsSorting]="fundingItemTransactionsSorting$ | async"
    (transactionsSortingChanged)="onFundingItemTransactionsSortingChanged($event)"
    [transactionsFilter]="fundingItemTransactionsFilter$ | async"
    (transactionsFilterChanged)="onFundingItemTransactionsFilterChanged($event)"
    (exportTransactionsToCsv)="onExportTransactionsToCsv($event)"
    [fundingItemMidFees]="fundingItemMidFees$ | async"
    [fundingItemMidFeesLoading]="fundingItemMidFeesLoading$ | async"
    [fundingItemMidFeesError]="fundingItemMidFeesError$ | async"
    [fundingItemAdjustments]="fundingItemAdjustments$ | async"
    [fundingItemAdjustmentsLoading]="fundingItemAdjustmentsLoading$ | async"
    [fundingItemAdjustmentsError]="fundingItemAdjustmentsError$ | async"
    (cancel)="onCancel()">
</app-funding-item-details>
